export function sortByCodeOrder<T extends { code: string }>(
	items: T[],
	order: readonly string[],
): T[] {
	return [...items].sort((a, b) => {
		const aRank = order.indexOf(a.code);
		const bRank = order.indexOf(b.code);
		return (aRank === -1 ? order.length : aRank) - (bRank === -1 ? order.length : bRank);
	});
}
